import { BaseModel } from "../abstracts/base.model";

export class ExamAnswerModel extends BaseModel {
    ExamAnswerListID: number;
    SubjectID: number
    QuestionID: number
    QuestionAnswerID: number

    SubjectName: string
}